module.exports = __webpack_public_path__ + "prod/1.42.2/img/distribution-two.74ce2d9d.png";